import React from "react";
import BinIcon from "./BinIcon";

function DeleteButton({
  onClick,
  title,
  disabled = false,
  label = "Delete item",
}) {
  return (
    <button
      type="button"
      aria-label={label}
      title={title}
      disabled={disabled}
      className="flex h-8 w-8 items-center justify-center rounded bg-red-200 text-red-800 hover:bg-red-300 disabled:cursor-not-allowed disabled:opacity-50"
      onClick={onClick}
    >
      <BinIcon className="h-4 w-4 fill-current" />
    </button>
  );
}

export default DeleteButton;
